import {Grid} from "@material-ui/core";
import {Typography} from "../../../../components/Wrappers";
import {Cell, Pie, PieChart, ResponsiveContainer} from "recharts";
import React from "react";
import useStyles from "../../styles";
import { useTheme } from "@material-ui/styles";
import Widget from "../../../../components/Widget";

export default ({data}) => {
    const classes = useStyles(useTheme())
    return (
        <Widget
            title="Device Health"
            className={classes.card}
            bodyClass={classes.alignStandaloneElement}
            disableWidgetMenu
        >
        <Grid container spacing={3}>
            <Grid
                item
                xs={6}
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 6
                }}
            >
                <Typography
                    variant={"caption"}
                    weight={"medium"}
                    style={{position: "absolute"}}
                >
                    {data.reduce((accum, row) => accum + row.value, 0)}
                </Typography>
                <ResponsiveContainer width="100%" height={144}>
                    <PieChart>
                        <Pie
                            data={data}
                            innerRadius={30}
                            outerRadius={40}
                            dataKey="value"
                        >
                            {data.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={entry.color}
                                    stroke={""}
                                />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </Grid>
            <Grid item xs={6}>
                <div className={classes.pieChartLegendWrapper}>
                    {data.map(({name, value, color}, index) => (
                        <div key={color} className={classes.legendItemContainer}>
                            <div className={classes.dot} style={{backgroundColor: color}}></div>
                            <Typography
                                color="text"
                                colorBrightness={"hint"}
                                variant={"caption"}
                                noWrap
                            >
                                &nbsp;{name}&nbsp;
                            </Typography>
                            <Typography color="text" weight={"medium"}>
                                &nbsp;{value}
                            </Typography>
                        </div>
                    ))}
                </div>
            </Grid>
        </Grid>
        </Widget>
    )
}